export const about_menu = [
    {
        'name': '關於',
        'node': true, 
        'layer1': true, 
        'radio_name': 'aboutroot',
        'children': [
            {
                'id': 'qplus_1',
                'name': '關於 QPlus',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_qplus',
                'index': 1,
                'checked': false
            },
            {
                'id': 'qplus_2',
                'name': '政府網站資料開放宣告',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_announcement',
                'index': 2,
                'checked': false
            },
            {
                'id': 'qplus_3',
                'name': '資訊安全政策',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_save',
                'index': 3,
                'checked': false
            },
            {
                'id': 'qplus_4',
                'name': '隱私權保護政策',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_privacy',
                'index': 4,
                'checked': false
            },
            {
                'id': 'qplus_5',
                'name': '意見信箱',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_email',
                'index': 5,
                'checked': false
            },
            {
                'id': 'qplus_6',
                'name': '網站地圖',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_map',
                'index': 6,
                'checked': false
            },
            {
                'id': 'qplus_7',
                'name': '瀏覽器建議',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_browser',
                'index': 7,
                'checked': false
            },
            {
                'id': 'qplus_8',
                'name': 'Q&A',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_Q&A',
                'index': 8,
                'checked': false
            }
        ],
        'icon': null
    },
    {
        'name': '怎麼用', 
        'node': true, 
        'layer1': true, 
        'radio_name': 'useroot',
        'children': [
            {
                'id': 'qplus_9',
                'name': '產品說明',
                'node': false, 
                'type': 'link',
                'href': '/static/description/QPEplus_products.pdf',
                'layer1': false,
                'radio_name': 'about_qplus',
                'index': 1,
                'checked': false
            },
            {
                'id': 'qplus_10',
                'name': '操作說明',
                'node': false, 
                'type': 'link',
                'href': '/static/description/QPEplus_userguide.pdf',
                'layer1': false,
                'radio_name': 'about_direction',
                'index': 2,
                'checked': false
            }
        ],
        'icon': null
    }
];

export const en_about_menu = [
    {
        'name': 'About',
        'node': true, 
        'layer1': true, 
        'radio_name': 'aboutroot',
        'children': [
            {
                'id': 'qplus_1',
                'name': 'About QPlus',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_qplus',
                'index': 1,
                'checked': false
            },
            {
                'id': 'qplus_2',
                'name': 'Government Website Open Information Announcement',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_announcement',
                'index': 2,
                'checked': false
            },
            {
                'id': 'qplus_3',
                'name': 'Information Security Policy',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_save',
                'index': 3,
                'checked': false
            },
            {
                'id': 'qplus_4',
                'name': 'Right of privacy protection policy',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_privacy',
                'index': 4,
                'checked': false
            },
            {
                'id': 'qplus_5',
                'name': 'Contact Us',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_email',
                'index': 5,
                'checked': false
            },
            {
                'id': 'qplus_6',
                'name': 'Sitemap',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_map',
                'index': 6,
                'checked': false
            },
            {
                'id': 'qplus_7',
                'name': 'Browser Suggestions',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_browser',
                'index': 7,
                'checked': false
            },
            {
                'id': 'qplus_8',
                'name': 'Q&A',
                'node': false, 
                'type': 'cross_type_single_radio',
                'layer1': false,
                'radio_name': 'about_Q&A',
                'index': 8,
                'checked': false
            }
        ],
        'icon': null
    }
];